<template lang="pug" src="./cashback.pug"></template>
<style lang="scss" src="./cashback.scss" scoped></style>

<script>
import scroll from '@/utils/scroll'

import { mapState } from 'vuex'
import request from '@/utils/request'
import { debounce } from 'debounce'

export default {
    filters: {
        formatBrandName(brand) {
            return brand ? brand.name : '-'
        }
    },
    data: () => ({
        sorting: {
            rowsPerPage: 100
        },
        templateSystemId: null,
        template: false,
        templateGroupId: null,
        groups: [],
        disabled: false,
        fromDateModal: null,
        toDateModal: null,
        brandSearch: null,
        filters: {
            fromDate: null,
            toDate: null,
            enabled: null,
            wasStartedUp: null,
            finished: null,
            countClientsFrom: null,
            countClientsTo: null,
            totalOrderFrom: null,
            totalOrderTo: null,
            name: null,
            brandId: null,
            isDelivery: null,
            bonusSystem: 'cashbackPercent'
        }
    }),
    computed: {
        ...mapState({
            isLoaded: (state) => state.cashback.isLoaded,
            systems: (state) => state.cashback.systems,
            pagination: (state) => state.cashback.pagination,
            brands: (state) => state.app.completedBrands,
            appliedFilters: (state) => state.cashback.filters
        }),
        headers() {
            return [
                { text: 'id', value: 'id' },
                { text: 'name', value: 'name' },
                { text: 'groupId', value: '"group.name"' },
                { text: 'groupType', value: '"group.isDelivery"' },
                { text: 'brand', value: '"group.brand.name"', sortable: false },
                { text: 'fromDate', value: '"fromDate"' },
                { text: 'toDate', value: '"toDate"' },
                { text: 'enabled', value: '"enabled"' },
                this.appliedFilters.bonusSystem === 'cashbackPercent' && { text: 'wasStartedUp', value: '"wasStartedUp"' },
                { text: 'progress', sortable: false, class: 'progress' },
                { text: 'clients', value: '"group.clients"' },
                { text: 'totalOrderCount', value: '"totalOrderCount"' },
                { text: 'totalCommission', value: '"totalCommission"' },
                { text: 'totalCashback', value: '"totalCashback"' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'deletedAt', value: '"deletedAt"' },
                { text: 'actions', sortable: false }
            ].filter(Boolean).map(it => Object.assign(it, {
                text: this.$vuetify.lang.t(`$vuetify.pages.Cashback.table.${it.text}`)
            }))
        },
        booleanSelect: function() {
            return [true, false].map(it => ({
                text: this.$vuetify.t(`$vuetify.${it}`),
                value: it
            }))
        },
        table_bonusSystemOptions: function() {
            const translationPath = '$vuetify.pages.Groups.table.bonusSystems'
            return ['cashbackPercent', 'count', 'sum'].map(it => ({
                text: this.$vuetify.t(`${translationPath}.${it}`),
                value: it
            }))
        },
        endpointRoot() {
            switch (this.appliedFilters.bonusSystem) {
                case 'cashbackPercent':
                    return '/cashback'

                case 'sum':
                    return '/reach-amount-bonus'

                case 'count':
                    return '/time-limited-bonus'
            }

            return '/'
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getSystems()
            },
            deep: true
        },
        brandSearch: debounce(function(query) {
            if (typeof query != 'string') return

            this.$store.dispatch('getCompletedBrands', {
                query
            })
        }, 500)
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getSystems()

        this.$store.dispatch('getCompletedBrands', { query: '' })
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('cashback/SET_PAGINATION', { page: 1, length: null })
        // this.$store.commit('cashback/RESET_FILTERS')
        next()
    },
    methods: {
        getRowColor(props) {
            return {
                'not-started': this.filters.bonusSystem === 'cashbackPercent' ? !props.item.wasStartedUp : !props.item.enabled,
                'expired': (new Date(props.item.toDate) < new Date()) || props.item.deletedAt
            }
        },
        getSystems(page = 1, isScrollEnable = false) {
            this.$store.dispatch('cashback/getSystems', {
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        resetFilters() {
            this.$store.commit('cashback/RESET_FILTERS')
            this.filters = Object.assign({}, this.appliedFilters)
            this.getSystems()
        },
        submit() {
            this.$store.commit('cashback/SET_FILTERS', Object.assign({}, this.filters))
            this.getSystems()
        },
        changeFromDate(date) {
            this.fromDateModal = false
        },
        changeToDate(date) {
            this.toDateModal = false
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getSystems(page, true)
            }
        },
        addCashbackSystem() {
            this.$router.push('/cashback/editor/?type=' + this.filters.bonusSystem)
        },
        progressColor(item) {
            return item.enabled && item.wasStartedUp && !item.deletedAt ? 'success' : 'grey'
        },
        progressPercent(item) {
            return (+item.progress / (+(item.group ? item.group.clients : 0) * +item.countOfSequences)) * 100 || 0
        },
        async templateModal(systemId) {
            this.templateSystemId = systemId
            this.template = true

            await this.getGroups()
        },
        async getGroups() {
            await request({
                method: 'get',
                url: this.endpointRoot + '/groups'
            }).then(res => {
                if (res.data) {
                    this.groups = res.data.groups
                }
            })
        },
        async useSystemAsTemplate() {
            if (this.disabled) return

            this.disabled = true

            await request({
                method: 'post',
                url: `${this.endpointRoot}/${this.templateSystemId}/${this.templateGroupId}/template`
            }).then(res => {
                if (res.status == 204) {
                    this.getSystems()

                    this.groups = this.groups.filter(it => it.id == !this.templateGroupId)

                    this.templateSystemId = null
                    this.templateGroupId = null

                    this.$store.dispatch('addMessage', {
                        type: 'success',
                        message: 'success',
                        locale: true
                    }, { root: true })
                }
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    this.$store.dispatch('addMessage', {
                        type: 'error',
                        message: error.response.data.message,
                        locale: false
                    }, { root: true })
                }
            }).finally(_ => {
                this.disabled = false
                this.template = false
            })
        }
    }
}
</script>
